import { RootFiIntegration } from '@prisma/client';

export interface Address {
  address_line_1: string;
  address_line_2?: string;
  address_line_3?: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
}

export interface Addresses {
  ship_from: Address | null;
  ship_to: Address;
}

export interface LogEntry {
  message: string;
  severity: string;
  time: string;
}

export interface CalculationLogGroup {
  logs: LogEntry[];
}

export interface TaxBreakdown {
  jurisdiction_name: string;
  jurisdiction_type: string;
  rate: number;
}

export interface TaxedLineItem {
  amount: number;
  effective_tax_rate: number;
  product_id: string;
  product_source_platform: string;
  product_source_platform_id: string;
  quantity: number;
  tax_code: string;
  taxable_amount: number;
  total_tax_due: number;
}

export interface CustomerDetails {
  customer_id: string;
  source_platform?: string;
  source_platform_id?: string;
}

export interface LineItem {
  amount: number;
  discount: number;
  line_item_id: string | null;
  line_number: number;
  product_id: string | null;
  product_sku: string | null;
  product_source_platform: string;
  product_source_platform_id: string;
  product_taxability_code: string;
  quantity: number;
}

export interface CalculationOutput {
  addresses: Addresses;
  calculation_log_group: CalculationLogGroup;
  corporation_id: string;
  customer_details: {
    customer_id: string;
  };
  discount: number;
  id: string;
  line_items: TaxedLineItem[];
  tax_currency: string;
  transaction_currency: string;
  transaction_date: string;
}

export enum CalculationEntityType {
  INVOICE = 'INVOICE',
  ESTIMATE = 'ESTIMATE',
}

export interface CalculationInput {
  addresses: Addresses;
  corporation_id: string;
  customer_details: CustomerDetails;
  discount: number;
  line_items: {
    items: LineItem[];
  };
  source_platform: string;
  source_platform_entity_id: string;
  source_platform_entity_type: CalculationEntityType;
  source_connection_id: string;
  transaction_currency: string;
  transaction_date: string;
  transaction_type: string;
}

export interface TaxCalculationData {
  ID: string;
  Input: CalculationInput;
  Output: CalculationOutput;
  CalculationDate: string;
  CorporationID: string;
  SourcePlatformEntityType: CalculationEntityType;
  SourcePlatform: RootFiIntegration;
  SourcePlatformEntityID: string;
  SourceConnectionID: string;
  CreatedAt: string;
}

export interface TaxCalculationResponse {
  data: TaxCalculationData;
  message: string;
}

export interface CalculationListResponse {
  data: TaxCalculationData[];
  nextCursor: string;
  totalCalculations: number;
}

export interface ListCalculationsParams {
  filters: {
    corporationId: number;
    from_date?: string;
    to_date?: string;
    search_term?: string;
  };
  cursor?: string | null;
  limit?: number;
}

export interface GetCalculationParams {
  calculationId: string;
  corporationId: number;
}
